// Copyright © 2024 The Things Industries B.V.

import { selectWebhooksConfiguration, selectAsStore } from './application-server'

// eslint-disable-next-line import/prefer-default-export
export const selectWebhooksQueueConfiguration = state =>
  selectWebhooksConfiguration(state).queue || { enabled: false }

export const selectStoredMessages = state => selectAsStore(state).storedMessages
export const selectApplicationStoredMessagesLoading = state =>
  selectAsStore(state).applicationStoredMessagesLoading
export const selectDeviceStoredMessagesLoading = state =>
  selectAsStore(state).deviceStoredMessagesLoading
export const selectAppStoredMessagesCount = state => selectAsStore(state).appTotalStoredMessages
